module.exports = __webpack_public_path__ + "img/1-1-conselleria-de-fons-europeus-universitat-i-cultura-govern-de-les-illes-balears.e1e1cfcd.png";